<template>
  <div class="manage-var">
    <h1>Manage Value-added Resalers</h1>
    <ConferVAR />
    <div class="var-list">
      <ValueAddedResalerSelect
        v-for="user in vars"
        :key="user.id"
        :user="user" />
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapState } from 'vuex';
import ValueAddedResalerSelect from './ValueAddedResalerSelect';
import ConferVAR from './ConferVAR';

export default {
  name: 'ManageValueAddedResalers',
  hagridActions: ['VARs/fetch', 'Orgs/fetch'],
  computed: {
    ...mapState({
      vars: state => state.VARs.data,
      orgs: state => state.Orgs.orgs,
    }),
  },
  components: {
    ValueAddedResalerSelect,
    ConferVAR,
  },
};
</script>

<style scoped>
.var-list {
  padding-top: 30px;
}
.var-container {
  display: flex;
  margin: auto;
  width: 90%;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/ManageValueAddedResalers.vue